import { Avatar, Box, Chip, colors, Drawer, Fab, Grid, IconButton, Paper, styled, Tab, TableRow, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeIcon from '@mui/icons-material/Mode';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get_all_followups, getAvailableAccess, getDocuments, getMembersSummary, update_followup } from '../Redux/Actions/action';
import { showLoader } from '../Redux/Slices/loaderSlice';
import StatusBox from '../Components/Documents/StatusBox';
import CommonSearchField from '../Components/Common/CommonSearchField';
import CommonTable from '../Components/Common/CommonTable';
import StyledTableCell from '../Components/Common/styledTableCell';
import ErrorHandler, { capitalizeFirstLetterOfWords, checkAccess, CommonChip, CommonChipFollowUpStatus, CommonStatusBox, CustomTooltip, getValuebyId, PaymentShowBox } from '../Utils/handler';
import CustomPagination from '../Components/Common/CommonPagination';
import { BucketURL } from '../ApiSetup/Api';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { TabContext, TabList } from '@mui/lab';
import DataNotFound from '../Components/Common/DataNotFound';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import dayjs from 'dayjs';
import CustomDialog from '../Components/Common/CustomDialog';
import ButtonContained from '../Components/Common/ButtonContained';
import CommonDropDown from '../Components/Common/CommonDropDown';
import { followUpStatusMemberRquest } from '../Utils/enum';
import TextLabel from '../Components/Common/CommonTextLabel';
import CommonTextField from '../Components/Common/CommonTextField';
import { useSelector } from 'react-redux';
import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import ButtonOutlined from '../Components/Common/ButtonOutlined';

const useStyles = makeStyles()((theme) => ({
}))

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    borderBottom: `1px solid lightgrey`,
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

function DocumentsViewStatus() {
    // ---------- Hook -----------
    const { classes } = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch()
    const sm = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const dataAccess = useSelector(value => value?.allAvailableAccess?.AllAvailableAccessList);
    const availableAccess = dataAccess?.filter((e) => e.path === pathname)?.[0]?.actionsType;
    const [searchParams, setSearchParams] = useSearchParams();


    // --------------- State -------------
    const [tableData, setTableData] = useState({})
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [searchText, setSearchText] = useState("");
    const [isSearch, setIsSearch] = useState(false);
    const [candidate, setCandidate] = useState({})
    const [membersSummary, setMembersSummary] = useState();
    const [open, setOpen] = useState(false);
    const [memberId, setMemberId] = useState({});
    const [allFollowups, setAllFollowups] = useState();
    const [followUpStatus, setFollowUpStatus] = useState({
        followUpStatus: "",
        remark: ""
    });
    const [error, setError] = useState('');
    const [data, setData] = useState({});
    const [status, setStatus] = useState("All");
    const [isFilter, setIsFilter] = useState(false);
    const [isApply, setIsApply] = useState(false);

    const tabData = [
        { label: "Login Users", value: "0", tabLabel: "Login Users Tab", isView: availableAccess?.some((e) => e === "Login Users Tab"), color: theme.palette.primary.main },
        { label: "Draft", value: "1", tabLabel: "Draft Tab", isView: availableAccess?.some((e) => e === "Draft Tab"), color: "rgba(245, 134, 52, 1)" },
        { label: "Approved", value: "2", tabLabel: "Approved Tab", isView: availableAccess?.some((e) => e === "Approved Tab"), color: "rgba(11, 176, 108, 1)" },
        { label: "Rejected", value: "3", tabLabel: "Rejected Tab", isView: availableAccess?.some((e) => e === "Rejected Tab"), color: "rgba(227, 54, 41, 1)" },
        { label: "Partial-Rejected", value: "4", tabLabel: "Partial-Rejected Tab", isView: availableAccess?.some((e) => e === "Partial-Rejected Tab"), color: "rgba(252, 171, 17, 1)" },
        { label: "Not-Interested", value: "5", tabLabel: "Not Interested Tab", isView: availableAccess?.some((e) => e === "Not Interested Tab"), color: "purple" },
    ];

    const urlTab = searchParams.get("tab");
    const defaultTab = tabData.find(tab => tab.isView)?.value || "0";

    const initialTab = tabData?.some(tab => tab.value === urlTab) ? urlTab : defaultTab;

    const [tabValue, setTabValue] = useState(initialTab);
    const [value, setValue] = useState(initialTab);
    const [sorting, setSorting] = useState({
        isPpskId: "",
        isSubmittedDate: "",
        isUpdatedDate: "",
        isRenewDays: "",
        isVerifyBy: "",
        isPaymentDate: ""
    });

    // --------------- handleChange ---------------
    const handelChangeFlolowUp = (e) => {
        const { name, value } = e.target;

        setFollowUpStatus({
            ...followUpStatus,
            [name]: value
        })
    }

    const handleClear = () => {
        setOpen(false);
        setFollowUpStatus({
            followUpStatus: "",
            remark: ""
        });
        setError("")
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const viewHandler = (item) => {
        navigate(`/documents-view?id=${item._id}`);
        setCandidate(item)
    }

    const _generateExcel = (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        const headerRowValues = [
            "No",
            "PPSK Id",
            "Name",
            "Contact No.",
            "Reference Contact No.",
            "Gender",
            "Submitted Date",
            "Updated Date",
            "Status",
            "Payment Status",
            "Followup Status",
        ];
        const headerRow = worksheet.addRow(headerRowValues);

        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '3e4094' } // Background color
            };
            cell.font = { bold: true, color: { argb: 'FFFFFF' } }; // White text, bold font
        });
        // Add data rows
        data?.forEach((document, index) => {
            console.log(document, "document")
            worksheet.addRow([
                index + 1,
                document?.ppskId || "-",
                document?.fullName || "-",
                document?.phoneNumber || "-",
                document?.otherDetails?.referencePersonContactNumber || "-",
                document?.generalDetails?.gender || "-",
                dayjs(document?.createdAt).format("ll") || "-",
                dayjs(document?.updatedAt).format("ll") || "-",
                document?.verificationStatus || "-",
                document?.policyStatus?.transaction?.status || "-",
                document?.followUpStatus || "-",
            ]);
        });

        worksheet.columns = [{ width: 10 }, { width: 20 }, { width: 40 }, { width: 20 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 40 }];
        // Save workbook to file
        workbook.xlsx.writeBuffer().then(buffer => {
            const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(data, `${`${value === '0' ? "Login Users" : value === '1' ? 'Draft' : value === '2' ? 'Approved' : value === '3' ? 'Rejected' : value === '4' ? ["Re-Uploaded", "Partial-Rejected"] : value === '5' ? "Not-Interested" : ""} Members ${dayjs(new Date()).format('DD/MM/YYYY')}`}`);
        }).catch(err => {
            console.error("Error generating Excel:", err);
        });
    };

    // --------------- Api  ---------------
    const getAllFollowups = async (id) => {
        dispatch(showLoader(true))
        let body = { id: id }
        try {
            const result = await dispatch(get_all_followups(body));
            const error = ErrorHandler(result);
            if (error) {
                console.log(result?.payload, "dsdsdsdsds")
                setAllFollowups(result?.payload?.data?.followUps)
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    const _addFollowups = async () => {
        if (!followUpStatus?.followUpStatus) {
            setError({ followUpStatus: "* Please select any status!" })
            return
        }
        dispatch(showLoader(true))
        try {
            let body = {
                "id": memberId,
                "currentStatus": getValuebyId(followUpStatus?.followUpStatus, followUpStatusMemberRquest),
                "remark": followUpStatus?.remark || ""
            }
            const result = await dispatch(update_followup(body))
            const error = ErrorHandler(result)
            if (error) {
                toast.success(result?.payload?.message);
                _getSummaryDetails();
                setFollowUpStatus({ followUpStatus: "", remark: "" });
                setOpen(false);
                setError({});
                _getDocumetsData();
            }
        } catch (error) {
            toast.error(error?.message || "An unknown error occurred");
        } finally {
            dispatch(showLoader(false))
        }
    }

    const _removeFromNonInterested = async (id) => {
        dispatch(showLoader(true))
        try {
            let body = {
                "id": id,
                "currentStatus": "Pending",
                "remark": ""
            }
            const result = await dispatch(update_followup(body))
            const error = ErrorHandler(result)
            if (error) {
                toast.success(result?.payload?.message);
                _getSummaryDetails();
                _getDocumetsData();
            }
        } catch (error) {
            toast.error(error?.message || "An unknown error occurred");
        } finally {
            dispatch(showLoader(false))
        }
    }

    const _getDocumetsData = async () => {
        dispatch(showLoader(true))
        const verificationStatus = value === '0' ? "Login Users" : value === '1' ? 'Draft' : value === '2' ? 'Approved' : value === '3' ? 'Rejected' : value === '4' ? ["Re-Uploaded", "Partial-Rejected"] : value === '5' ? "Not-Interested" : '';
        let body = {
            search: searchText || '',
            page: page,
            limit: rowsPerPage,
            verificationStatus: verificationStatus,
            status: status,
            isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
            isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
            isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
            isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
            isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
            isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
        }

        try {
            const result = await dispatch(getDocuments(body));
            const error = ErrorHandler(result);
            if (error) {
                // toast.success(result?.payload?.message);
                setTableData(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    const _getSummaryDetails = async () => {
        dispatch(showLoader(true))
        let body = {}
        try {
            const result = await dispatch(getMembersSummary(body));
            const error = ErrorHandler(result);
            if (error) {
                setMembersSummary(result?.payload?.data?.counts)
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    const _downloadMembers = async () => {
        dispatch(showLoader(true))
        const verificationStatus = value === '0' ? "Login Users" : value === '1' ? 'Draft' : value === '2' ? 'Approved' : value === '3' ? 'Rejected' : value === '4' ? ["Re-Uploaded", "Partial-Rejected"] : value === '5' ? "Not-Interested" : '';
        let body = {
            search: searchText || '',
            verificationStatus: verificationStatus,
            status: status,
            isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
            isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
            isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
            isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
            isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
            isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
        }
        try {
            const result = await dispatch(getDocuments(body));
            const error = ErrorHandler(result);
            if (error) {
                console.log(result?.payload?.data?.members, "result?.payload?.data?.members")
                _generateExcel(result?.payload?.data?.members)
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    // --------- useEffect ----------
    useEffect(() => {
        _getSummaryDetails()
    }, [value, searchText, isApply])

    useEffect(() => {
        if (searchText) {
            setTimeout(() => {
                _getDocumetsData()
            }, 500);
        } else {
            _getDocumetsData()
        }
    }, [page, rowsPerPage, value, searchText, isApply, sorting])

    useEffect(() => {
        setSearchParams({ tab: tabValue }); // Store tab number in URL
    }, [tabValue, setSearchParams]);

    const tableHeaders = [
        "No",
        "Photo",
        "PPSK ID",
        "Name",
        "Mobile No",
        value !== '2' && "Gender",
        "Submitted Date",
        "Updated Date",
        value === '0' && "Followup Status",
        value === '2' && "Payment",
        value === '2' && "Payment Date",
        value === '2' && "Start Date",
        value === '2' && "End Date",
        value === '2' && "Remaining Renew Days",
        value === '2' && "Verified By",
        value === "4" && "Verification Status",
        (checkAccess(pathname, dataAccess, 'Action View') || checkAccess(pathname, dataAccess, 'Action Edit')) && "Action"
    ]?.filter(Boolean)

    return (
        <Grid container spacing={2} xs={12} sm={12} md={12} lg={12}>
            <Grid item xs={12}>
                <Paper elevation={0} sx={{ padding: 2, background: { md: "#fff", xs: "none", borderRadius: '20px', border: `1px solid lightgrey` } }}>
                    <Box display={"flex"} justifyContent={"end"} gap={1} ml={"auto"} mb={1}>
                        <Tooltip title={`Search`}>
                            {!isSearch &&
                                <Fab sx={{
                                    width: '46px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, border: '1px solid rgba(34, 34, 34, 0.3)', borderRadius: '10px', backgroundColor: "transparent", color: "rgba(34, 34, 34, 0.3)",
                                }} onClick={() => setIsSearch(true)}>
                                    <SearchIcon sx={{ fontSize: '24px' }} />
                                </Fab>
                            }
                            {isSearch &&
                                <CommonSearchField placeholder={"Search.."} tooltipList={['Name', "AadharCard Number", "Mobile Number"]} handleSearch={(e) => { setPage(1); setSearchText(e); }} />
                            }
                        </Tooltip>
                        {(value == "0" || value == "2" || value == "4") &&
                            <Tooltip title={`Filter`}>
                                <Fab sx={{
                                    width: '90px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, border: '1px solid rgba(34, 34, 34, 0.3)', borderRadius: '10px', backgroundColor: "transparent", color: "rgba(34, 34, 34, 0.5)",
                                }} onClick={() => setIsFilter(true)}>
                                    <TuneIcon sx={{ fontSize: '20px', mr: 1 }} /> Filter
                                </Fab>
                            </Tooltip>
                        }
                        <Tooltip title={`Download ${value === '0' ? "Login Users" : value === '1' ? 'Draft' : value === '2' ? 'Approved' : value === '3' ? 'Rejected' : value === '4' ? ["Re-Uploaded", "Partial-Rejected"] : value === '5' ? "Not-Interested" : ''} Member`}>
                            <Fab disabled={tableData?.members?.length === 0} sx={{
                                width: '56px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, borderRadius: '10px', backgroundColor: tabData?.filter((e) => e?.value == tabValue)?.[0]?.color, color: theme.palette.common.white, "&:hover": {
                                    background: tabData?.filter((e) => e?.value == tabValue)?.[0]?.color, color: theme.palette.common.white
                                }
                            }} onClick={() => _downloadMembers()}>
                                <FileDownloadOutlinedIcon sx={{ fontSize: '24px' }} />
                            </Fab>
                        </Tooltip>
                    </Box>
                    <TabContext value={value}>
                        <Box mb={1}>
                            <TabList
                                onChange={(e, newValue) => {
                                    if (newValue !== undefined) {
                                        setValue(newValue);
                                        setTabValue(newValue);
                                    }
                                    setPage(1);
                                    setStatus("All"); setSorting({
                                        isPpskId: "",
                                        isSubmittedDate: "",
                                        isUpdatedDate: "",
                                        isRenewDays: "",
                                        isVerifyBy: "",
                                        isPaymentDate: ""
                                    })
                                }}
                                aria-label="tabs with icons"
                                sx={{
                                    "& .MuiTabs-indicator": {
                                        display: "none",
                                    },
                                    "& .Mui-selected": {
                                        background: tabData?.filter((e) => e?.value == tabValue)?.[0]?.color,
                                        color: `${theme.palette.common.white} !important`
                                    },
                                }}
                            >
                                {tabData?.map((tab) => {
                                    return (
                                        checkAccess(pathname, dataAccess, tab?.tabLabel) &&
                                        <Tab label={`${tab?.label} (${membersSummary?.find((e) => e?.status == tab?.label)?.statusCount || 0})`} value={tab?.value} sx={{ marginRight: '10px', border: `2px solid ${tab.color}`, borderRadius: '10px', color: tab.color, height: '40px', minHeight: '0px' }} />
                                    )
                                })}

                            </TabList>
                        </Box>
                    </TabContext>

                    <CommonTable headerList={tableHeaders} align={'center'} minWidth={600} setSorting={setSorting} sorting={sorting} backgroundColor={tabData?.filter((e) => e?.value == tabValue)?.[0]?.color}>

                        {tableData?.members?.length > 0 ? tableData?.members?.map((document, index) => {
                            let image = document?.personalDetails?.image ? BucketURL + document?.personalDetails?.image : "No"
                            return (
                                <TableRow key={index}>

                                    <StyledTableCell sx={{ position: "relative", padding: "0px", width: "75px" }} align="center">
                                        {/* <Box sx={{ position: "absolute", top: 0, left: 0, margin: "-5px 0px 0px -2px" }}                                        >
                                            <CommonChip label={document?.verificationStatus} status={document?.verificationStatus} height={"20px"} width={"auto"} margin={"18px 0px 0px 2px"} padding={"2px 8px"} />
                                        </Box> */}
                                        <Box>{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</Box>
                                    </StyledTableCell>
                                    <StyledTableCell align="center" >
                                        <Box display={'flex'} justifyContent={'center'}>
                                            <Avatar src={image} slotProps={{ img: { loading: 'lazy', } }} sx={{ borderRadius: '6px' }} />
                                        </Box>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{document?.ppskId || "-"}</StyledTableCell>
                                    <StyledTableCell align="center" sx={{}}>{capitalizeFirstLetterOfWords(document?.fullName || "-")}</StyledTableCell>
                                    <StyledTableCell align="center">{document?.phoneNumber ? document?.phoneNumber : document?.personalDetails?.phoneNumber ? document?.personalDetails?.phoneNumber : "-"}</StyledTableCell>
                                    {value !== '2' &&
                                        <StyledTableCell align="center">{capitalizeFirstLetterOfWords(document?.personalDetails?.gender || "-")}</StyledTableCell>
                                    }
                                    <StyledTableCell align="center">{dayjs(document?.createdAt).format("ll") || "-"}</StyledTableCell>
                                    <StyledTableCell align="center">{dayjs(document?.updatedAt).format("ll") || ""}</StyledTableCell>
                                    {value === '2' && <StyledTableCell align="center">

                                        <PaymentShowBox value={document?.policyStatus?.transaction?.status || "PENDING"} />

                                    </StyledTableCell>}

                                    {value === '0' &&
                                        <StyledTableCell align="center" onClick={() => { setOpen(true); setMemberId(document?._id); getAllFollowups(document?._id) }}>
                                            <Box sx={{ cursor: "pointer", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Tooltip title={document?.followUpStatus}>
                                                    <Box width={"100px"} >
                                                        <CommonChipFollowUpStatus fontSize={"13px"} height={"28px"} label={document?.followUpStatus} />
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                        </StyledTableCell>}
                                    {
                                        value === '2' &&
                                        <StyledTableCell align="center">{document?.policyStatus?.transactionDate ? dayjs(document?.policyStatus?.transactionDate).format("ll") : "-"}</StyledTableCell>
                                    }
                                    {
                                        value === '2' &&
                                        <StyledTableCell align="center">{document?.policyStatus?.activeAt ? dayjs(document?.policyStatus?.activeAt).format("ll") : "-"}</StyledTableCell>
                                    }
                                    {
                                        value === '2' &&
                                        <StyledTableCell align="center">{document?.policyStatus?.expireAt ? dayjs(document?.policyStatus?.expireAt).format("ll") : "-"}</StyledTableCell>
                                    }
                                    {
                                        value === '2' && <StyledTableCell align="center">
                                            {document?.policyStatus?.remainingRenewDays ? document?.policyStatus?.remainingRenewDays + " days left" : "-"}
                                        </StyledTableCell>
                                    }
                                    {
                                        value === '2' && <StyledTableCell align="center">
                                            {document?.documentVerificationStatus?.verifiedBy || "-"}
                                        </StyledTableCell>
                                    }
                                    {value === "4" && <StyledTableCell align="center">
                                        <Box sx={{ cursor: "pointer", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <CommonStatusBox fontSize={"13px"} height={"28px"} label={document?.verificationStatus} />
                                        </Box>
                                    </StyledTableCell>}
                                    {value !== '5' && (checkAccess(pathname, dataAccess, 'Action View') || checkAccess(pathname, dataAccess, 'Action Edit')) &&
                                        <StyledTableCell align="center">
                                            {(document?.verificationStatus === 'Login Users') ?
                                                checkAccess(pathname, dataAccess, 'Action Edit') && <IconButton sx={{
                                                    padding: 0.5, "&:hover": {
                                                        border: "1px solid rgba(62, 64, 149, 1)",
                                                        background: "rgba(215, 223, 255, 1)",
                                                        borderRadius: "10px"
                                                    }
                                                }}
                                                    onClick={() => !document?.personalDetails?.aadhaarNumber ? navigate(`/addMember`) : navigate(`/addMember?id=${document?._id}&tabValue=${value}&step=0&isEdit=${true}`)}>
                                                    <DriveFileRenameOutlineOutlinedIcon fontSize='medium' color='primary' />
                                                </IconButton> :
                                                checkAccess(pathname, dataAccess, 'Action View') && <IconButton sx={{
                                                    padding: 0.5, "&:hover": {
                                                        border: "1px solid rgba(62, 64, 149, 1)",
                                                        background: "rgba(215, 223, 255, 1)",
                                                        borderRadius: "10px"
                                                    }
                                                }} onClick={() => viewHandler(document)}>
                                                    <VisibilityIcon fontSize='medium' color='primary' />
                                                </IconButton>
                                            }
                                        </StyledTableCell>}
                                    {value == '5' && (checkAccess(pathname, dataAccess, 'Action View') || checkAccess(pathname, dataAccess, 'Action Edit')) &&
                                        <StyledTableCell align="center">
                                            <CustomTooltip title={'Remove From Non-Interested'}>
                                                <IconButton sx={{ padding: 1 }} onClick={() => _removeFromNonInterested(document?._id)}>
                                                    <CancelIcon fontSize='medium' color='primary' />
                                                </IconButton>
                                            </CustomTooltip>
                                        </StyledTableCell>}
                                </TableRow>
                            )
                        }) :
                            <TableRow>
                                <StyledTableCell colSpan={12}>
                                    <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "2rem" }} />} elevation={0} />
                                </StyledTableCell>
                            </TableRow>
                        }
                    </CommonTable>
                    {tableData?.count > 0 &&
                        <Grid item xs={12}>
                            <CustomPagination
                                rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
                                count={Math.ceil(tableData?.count / rowsPerPage)}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage} />

                        </Grid>}
                </Paper>
            </Grid>
            {open &&
                <CustomDialog
                    isOpen={open} handleClose={handleClear} title={'Follow Up'} padding={'10px'}
                    maxWidth={"sm"}
                    action={<ButtonContained text={'Update'} onClick={() => _addFollowups()} minWidth={'auto'} />}
                >
                    <Grid container xs={12} spacing={1}>
                        <Grid item xs={12}>
                            {allFollowups?.length > 0 && allFollowups?.map((data, i) => {
                                return (
                                    <>
                                        <Grid container key={data?._id} alignItems="center" my={1} >
                                            {/* Status Button */}
                                            <Grid item xs={12} textAlign={"center"} sx={{ border: `1px dashed ${theme.palette.primary.main}`, borderRadius: "5px", padding: "5px" }}>
                                                <Box display={"flex"} justifyContent={"space-between"} >

                                                    <Box display={"flex"} flexDirection={"column"} alignItems={"start"} gap={"5px"}>
                                                        <Box display={"flex"} alignItems={"center"} gap={0.5}>
                                                            <Typography color={theme.palette.primary.main} fontSize={"12px"}>Status : </Typography>
                                                            <Typography variant="body1">
                                                                <CommonChipFollowUpStatus label={data?.currentStatus} />
                                                            </Typography>
                                                        </Box>

                                                        <Box display={"flex"} alignItems={"center"} gap={0.5}>
                                                            <Typography color={theme.palette.primary.main} fontSize={"12px"}>Date :</Typography>
                                                            <Typography variant="body2"> {data?.createdAt ? dayjs(data?.createdAt).format('LL') : "-"} </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Box display={"flex"} flexDirection={"column"} alignItems={"start"} gap={"5px"}>
                                                        <Box display={"flex"} alignItems={"center"} gap={0.5}>
                                                            <Typography color={theme.palette.primary.main} fontSize={"12px"}>Verify By :</Typography>
                                                            <Typography variant="body2"> {data?.changedBy} </Typography>
                                                        </Box>

                                                        <Box display={"flex"} alignItems={"center"} gap={0.5}>
                                                            <Typography color={theme.palette.primary.main} fontSize={"12px"}>Remark :</Typography>
                                                            <Tooltip title={data?.remark}>
                                                                <Box width={"120px"} textAlign={"start"} sx={{ cursor: "pointer" }}>
                                                                    <Typography variant="body2" noWrap>
                                                                        {data?.remark || "-"}
                                                                    </Typography>
                                                                </Box>
                                                            </Tooltip>
                                                        </Box>
                                                    </Box>

                                                </Box>

                                            </Grid>
                                        </Grid>
                                    </>
                                )
                            })}
                        </Grid>

                        <Grid item xs={12} >
                            <CommonDropDown
                                type="text"
                                text={'Follow Up Status'}
                                name={'followUpStatus'}
                                value={followUpStatus?.followUpStatus}
                                values={followUpStatusMemberRquest?.map((e) => e?.label) || []}
                                labelColor={theme?.palette?.primary?.main}
                                placeholder={`Select Id Proof`}
                                width={"100%"}
                                valid
                                onChange={handelChangeFlolowUp}
                            />
                            <TextLabel color="error" title={!followUpStatus?.followUpStatus ? error?.followUpStatus : ""} />
                        </Grid>
                        <Grid item xs={12} >
                            <CommonTextField
                                value={followUpStatus?.remark}
                                text="Remark"
                                type="text"
                                onChange={handelChangeFlolowUp}
                                labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                                labelColor={theme?.palette?.primary?.main}
                                name="remark"
                                rows={3}
                                multiline
                            />
                        </Grid>
                    </Grid >
                </CustomDialog>
            }
            {isFilter &&
                <Drawer role='presentation' variant="permanent" anchor={"right"}
                    open={isFilter} sx={{
                        '& .MuiDrawer-paper': {
                            width: { xs: "100%", sm: "100%", md: "400px" },
                            borderRight: '1px solid transparent',
                            // zIndex: 10000
                        }
                    }}>
                    <DrawerHeader>
                        <Box display="flex" gap={1} justifyContent="space-between" alignItems="center" width={"100%"}>
                            <Typography fontSize={"22px"} fontWeight={"bold"}>Filter</Typography>
                        </Box>
                    </DrawerHeader>
                    <Box p={1}>
                        <CommonDropDown
                            text={value == "0" ? "Verification Status" : value == "2" ? "Payment Status" : "Verification Status"}
                            name={"status"}
                            value={status}
                            values={
                                value == 0 ? [{ label: "All", value: "All" }, ...followUpStatusMemberRquest]?.map((val) => val?.value) : value == 2 ? [{ label: "All", value: "All" }, { label: "Pending", value: "Pending" }, { label: "Success", value: "Success" }, { label: "Cancel", value: "Cancel" }]?.map((val) => val?.value) : [{ label: "All", value: "All" }, { label: "Re-Uploaded", value: "Re-Uploaded" }, { label: "Partial-Rejected", value: "Partial-Rejected" }]?.map((val) => val?.value)
                            }
                            width={"100%"}
                            onChange={(e) => setStatus(e?.target?.value)}
                            notShowSelect
                        />
                    </Box>
                    <Box marginTop={"auto"} p={1} display={"flex"} gap={1} justifyContent={"end"}>
                        <ButtonOutlined text={"Close / Clear"} onClick={() => { setIsFilter(false); setStatus("All"); setIsApply(!isApply) }} border={`1px solid ${theme.palette.primary.main}`} />
                        <ButtonContained color={"primary"} text={"Apply"} onClick={() => { setIsApply(!isApply); setIsFilter(false); }} />
                    </Box>
                </Drawer >
            }
        </Grid >
    )
}

export default DocumentsViewStatus
